/**
 * Determines whether Cloudflare Turnstile should be initialized for the current page.
 *
 * Turnstile is used to ensure initial score/rating submissions come from humans (not bots),
 * so it is only needed when an initial `score` or `rating` is present in the query string.
 *
 * Turnstile also requires whitelisted domains. When `mode=widget`, the content may be embedded
 * on unknown/non-whitelisted domains, so we intentionally skip initialization.
 *
 * This check runs early to avoid initializing the Turnstile service when it isn't required,
 * since the initialization is relatively costly.
 */

export function shouldInitializeTurnstile(search: string): boolean {
    const p = new URLSearchParams(search);
    return (p.has('rating') || p.has('score')) && p.get('mode') !== 'widget';
}
